import {css} from 'lit';

export const labelStyles = css`
  :host {
    --label__border--focus: var(--_label__border--focus, var(--sbkLabelOnLightFocus));
    --label__color: var(--_label__color, var(--sbkLabelFgColorOnLightDefault));
    --label__color--disabled: var(--_label__color--disabled, var(--sbkLabelFgColorOnLightDisabled));
    --label__color--error: var(--_label__color--error, var(--sbkLabelFgColorOnLightError));
  }
  
  * {
    box-sizing: border-box;
  }
  
  .input__wrapper--error {
    & .label__wrapper {
      color: var(--label__color--error);
    }

    & sbk-button::part(button) {
      background: var(--label__color--error);
    }
  }

  .input__wrapper--disabled {
    & .label__wrapper {
      color: var(--label__color--disabled);
    }

    & sbk-button {
      cursor: not-allowed;
      pointer-events: none;
      
      &::part(button) {
        background: var(--label__color--disabled);
      }
    }
  }
    
    .label__text {
        hyphens: auto;
    }

  .label__wrapper {
    align-items: start;
    display: flex;
    gap: var(--sbkLabelSpacing4xs);
    
    .label {
      font: var(--sbkLabelTypographyLabel);
      margin-bottom: var(--sbkInput3xs);
    }
    
    i {
      font-style: normal;
    }
    
    .input__label-link {
      background: transparent;
      outline: 2px solid transparent;
      outline-offset: var(--sbkLabelBorderGapFocus);
      align-items: center;
      color: inherit;
      margin: 0;
      border: 0;
      padding: 0px 6px 6px;
      margin-top: -1px;
      cursor: pointer;

        @media (hover: hover) and (pointer: fine) {
            &:hover {
                color: var(--label__color--error)
            }
        }
      
      &:focus-visible {
        outline: var(--label__border--focus)
      }
    }
  }

    .label__text {
        hyphens: auto;
    }

    .sr-only {
        position: absolute;
        clip: rect(1px, 1px, 1px, 1px);
        padding: 0;
        border: 0;
        height: 1px;
        width: 1px;
        overflow: hidden;
    }
`;
